import React from 'react';

import * as S from './styles';

const News: React.FC = () => {
	return (
		<S.Container>
			<span>Assuntos do momento no Brasil</span>
			<strong>Bootcamp da Rocketseat</strong>
		</S.Container>
	);
};

export default News;
